import { render, staticRenderFns } from "./MultiplePopupMenu.vue?vue&type=template&id=473773e7&scoped=true&"
import script from "./MultiplePopupMenu.vue?vue&type=script&lang=js&"
export * from "./MultiplePopupMenu.vue?vue&type=script&lang=js&"
import style0 from "./MultiplePopupMenu.vue?vue&type=style&index=0&id=473773e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473773e7",
  null
  
)

export default component.exports